// extracted by mini-css-extract-plugin
export var desktopSearch = "Header-module--desktopSearch--yByW-";
export var header = "Header-module--header--pPkNJ";
export var mobileHeader = "Header-module--mobileHeader--cNTfR";
export var mobileLogo = "Header-module--mobileLogo--U31Ql";
export var mobileSearchButton = "Header-module--mobileSearchButton--Tw+QJ";
export var mobileSearchIcon = "Header-module--mobileSearchIcon--ws+NE";
export var searchHeader = "Header-module--searchHeader--QO5O5";
export var sidebarSubtitle = "Header-module--sidebarSubtitle--L9Nw7";